import { Component, Input } from '@angular/core';
import {  Platform } from 'ionic-angular';

/**
 * Generated class for the CommonHeaderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
   
  
@Component({
  selector: 'common-header',
  templateUrl: 'common-header.html'
})
export class CommonHeaderComponent {
  constructor(private platform: Platform) {
    
  }

}



// WEBPACK FOOTER //
// ./src/components/common-header/common-header.ts